import { useEffect, useState } from "react"
import { Box, Divider, Grid, TextField, Typography } from "@mui/material"
import _ from "lodash"
import { AppButton, Breadcrumb, CustomDialog, CustomStepper, DisplayMessage, Loader, StatusButton } from "../../components"
import { useStyles } from './style'
import pdfIcon from '../../assets/Images/pdfIcon.svg'
import history from "../../routes/history"
import { applicationsService } from "../../services"
import * as messageTypes from '../../utils/messageTypes'
import { downloadFile, trimName, trimNameWithoutExtension } from "../../utils/fileUtils"
import { applicationStatus, tableApplicationStatus } from "../Applications/constant"
import { useFormik } from "formik"
import * as yup from 'yup'
import { getErrors, getHelperText } from "../../utils/formikHelper"
import { APPLICATIONAPPROVED, APPLICATIONREJECTED, contentAlignment, SITEAPPROVED, SITEREJECTED, SITESUBMITTED, steps } from "./constant"
import download from '../../assets/Images/download.svg'
import { dashboardService } from "../../services/DashboardService"
import { AccessTime, ChevronRight } from '@mui/icons-material'
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@mui/lab'
import moment from "moment-timezone"
import { PROGRAM_KEY } from "../../constants/common"
import { timeZone, timeZoneAbbrs } from '../../utils/momentTimezones'
import Icon from "../../utils/icons"

moment.fn.zoneName = function () {
  const abbr = this.zoneAbbr()
  return timeZoneAbbrs[abbr] || abbr
}
const programsTypes = {
  'DATA_AND_DISPATCH': 'Data And Dispatch',
  'DATA_ONLY': 'Data Only'
}
const enchargeText = {
  'encharge3': 'IQ Battery 3',
  'encharge10': 'IQ Battery 10',
  'encharge5P': 'IQ Battery 5P'
}

const incentiveCategories = {
  'STANDARD': 'Standard User',
  'UNDERSERVED': 'Underserved User',
  'LOW_INCOME': 'Low Income User'
}

const paymentTypes = {
  'MONTHLY_INSTALLMENT': 'Monthly Installment',
  'UPFRONT_PAYMENT': 'Upfront Payment'
}

const validationSchema = yup.object({
  siteId: yup.string().required('Enphase Site Id is required').min(2, 'Enphase Site Id must be min 2 characters').max(10, 'Enphase Site Id must be max 10 characters').test('maxval', 'Invalid Enphase Site ID', val => Number(val) < Math.pow(2, 31)),
})

const ViewApplication = (props) => {
  const classes = useStyles()
  const [application, setApplication] = useState()
  const [openSiteModal, setOpenSiteModal] = useState(_.get(props, 'location.state.siteModal', false))
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState()
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)
  const [program, setProgram] = useState()
  const [formData, setFormData] = useState()
  const [leftContent, setLeftContent] = useState()
  const [rightContent, setRightContent] = useState()
  const [fileContent, setFileContent] = useState()
  const [showTimeline, setShowTimeline] = useState(false)
  const [urlProgram, setUrlProgram] = useState([])
  const [programsId, setProgramsId] = useState()
  const programId = props?.match?.params?.programId
  const applicationId = props?.match?.params?.applicationId

  const formik = useFormik({
    initialValues: {
      siteId: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      submitSiteId(values)
    }
  })

  const getApplicationById = () => {
    setLoading(true)
    applicationsService.getApplicationById(programId, applicationId)
      .then(applicationData => {
        setLoading(false)
        if (program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP) {
          let leftContent = [], rightContent = [], fileContent = []
          const contentAlignments = contentAlignment(program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : '')
          formData && formData.fields.forEach((field) => {
            if (field.type === 'GROUPABLE_COUNTER') {
              if (rightContent.find(content => content.label === field.label)) {
                let content = rightContent.find(content => content.label === field.label)
                let value = content?.value
                value?.push({ [field.application_field]: applicationData[field.application_field] ? applicationData[field.application_field] : applicationData.homeowner_info[field.application_field] })
                content.value = value
              } else {
                rightContent.push({ type: field.type, label: field.label, value: [{ [field.application_field]: applicationData[field.application_field] ? applicationData[field.application_field] : applicationData.homeowner_info[field.application_field] }] })
              }
            }
            if (contentAlignments?.LEFTGRIDCONTENT.includes(field.application_field)) {
              leftContent.push({ label: field.label, value: applicationData[field.application_field] ? field.type === 'DATE' ? moment.utc(applicationData[field.application_field]).tz(timeZone).format('DD/MM/YYYY') : applicationData[field.application_field] : applicationData.homeowner_info[field.application_field] })
            }
            if (contentAlignments?.RIGHTGRIDCONTENT.includes(field.application_field)) {
              rightContent.push({ label: field.label, value: applicationData[field.application_field] ? field.type === 'DATE' ? moment.utc(applicationData[field.application_field]).tz(timeZone).format('DD/MM/YYYY') : applicationData[field.application_field] : applicationData.homeowner_info[field.application_field] })
            }
          })
          formData && formData.files.forEach((file) => {
            fileContent.push({ label: file.label, value: applicationData[file.s3_url_field], downloadableUrl: applicationData[file.downloadable_url_field], type: file.media_type })
          })
          setFileContent(fileContent)
          setLeftContent(leftContent)
          setRightContent(rightContent)
        }
        setApplication(applicationData)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllProgramIds = () => {
    setLoading(true)
    applicationsService.getAllProgramIds(programId, true)
      .then(programsData => {
        let programIds = []
        programsData.forEach(program => {
          programIds.push(program.id)
        })
        setProgramsId(programIds.join(','))
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getProgram = () => {
    const programIds = programsId && programsId.split(',')
    setLoading(true)
    dashboardService.getAllPrograms()
      .then(programsData => {
        setLoading(false)
        let filteredPrograms = programsData.filter(program => program.feature_flags && program.feature_flags.installer_intake && programIds.includes(program.id))
        setUrlProgram(new URLSearchParams({ programs: filteredPrograms.map(obj => obj.id) }))
        setProgram(filteredPrograms)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getProgramDynamicForm = (programKey) => {
    setLoading(true)
    applicationsService.getDynamicForms(programKey)
      .then(formData => {
        setFormData(formData)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const submitSiteId = (values) => {
    setLoading(true)
    applicationsService.submitSiteId(applicationId, values.siteId)
      .then(siteData => {
        setLoading(false)
        formik.resetForm()
        setApplication(siteData)
        setOpenSiteModal(false)
        setOpen(true)
        setMessage('Site submitted successfully')
        setMessageType(messageTypes.SUCCESS)
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getSiteModalContent = () => {
    return (
      <Box px={3} py={0}>
        <Box mb={2}>
          <Box className={classes.modalKey}>Application ID</Box>
          <Box className={classes.modalValue}>{applicationId}</Box>
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            fullWidth
            className={classes.siteField}
            id="siteId"
            name="siteId"
            label="Enter Enphase Site ID"
            variant="standard"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]*/g, '')
            }}
            onChange={formik.handleChange}
            error={getErrors(formik.errors.siteId, formik.values.siteId, formik.touched.siteId)}
            helperText={getHelperText(formik.errors.siteId, formik.values.siteId, formik.touched.siteId)}
          />
          <Box my={2} textAlign="center">
            <a href="https://support.enphase.com/s/article/Where-do-I-find-my-system-Site-ID" className={classes.link} target="_blank" rel="noopener noreferrer">Where to find Enphase Site ID?</a>
          </Box>
          <Box >
            <AppButton text={application && application.site_id ? "Resubmit" : 'Submit'} type="submit" />
          </Box>
        </form>
      </Box>
    )
  }

  const getTimelineContent = () => {
    const length = application && application.log_history && application.log_history.length
    return (
      <Box>
        <Box className={classes.timelineWrapper}>
          <Timeline>
            {application && application.log_history && [...application.log_history].reverse().map((history, index) => (
              <TimelineItem key={history.timestamp}>
                <TimelineOppositeContent color="text.secondary" sx={{ maxWidth: 140, margin: '-11px 0px' }}>
                  <Box>
                    <Box className={classes.timelineLeftMainText}>{history.timestamp && moment.utc(history.timestamp).tz(timeZone).format('MMMM DD, YYYY')}</Box>
                    <Box className={classes.timelineLeftText}>{history.timestamp && moment.utc(history.timestamp).tz(timeZone).format('h:mm A z')}</Box>
                  </Box>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot variant="outlined" color="primary" sx={{ borderWidth: '4px', margin: '0px' }} />
                  {index + 1 !== length && <TimelineConnector color="primary" classes={{ root: classes.timelineConnector }} />}
                </TimelineSeparator>
                <TimelineContent sx={{ margin: '-11px 0px' }}>
                  <Box>
                    <Box className={classes.timelineRightMainText} component="span">{tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''] ? tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''][history.application_status][3] : ''}</Box>
                    <Box mx={1} className={classes.dotSeparator} component="span"></Box>
                    <Box className={classes.timelineRightText} component="span">{history.timestamp && moment.utc(history.timestamp).tz(timeZone).fromNow()}</Box>
                  </Box>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        </Box>
      </Box>
    )
  }

  const downloadUploadedFile = (fileurl, fileName) => {
    if (fileName.split('.')[1] === 'csv') {
      downloadFile(fileurl)
    }
    else {
      let popUp = window.open(fileurl, '_blank', '')
      if (popUp == null || typeof (popUp) == 'undefined') {
        setOpen(true)
        setMessage('Please disable your pop-up blocker and download file again.')
        setMessageType(messageTypes.INFO)
      }
    }
  }

  useEffect(() => {
    getAllProgramIds()
  }, [programId])

  useEffect(() => {
    if (programsId)
      getProgram()
  }, [programsId])

  useEffect(() => {
    if (program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP) {
      getProgramDynamicForm(program[0].program_key)
    }
  }, [program])

  useEffect(() => {
    if (program && program[0]) {
      if (program[0].program_key === PROGRAM_KEY.APS_RBP) {
        getApplicationById()
      } else {
        if (formData) {
          getApplicationById()
        }
      }
    }
  }, [program, formData])

  return (
    <Box>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      {openSiteModal && <CustomDialog open={openSiteModal} title="" content={getSiteModalContent()} fullWidth maxWidth="xs" handleClose={() => { formik.resetForm(); setOpenSiteModal(false) }} />}
      {showTimeline && application && <CustomDialog open={showTimeline} classes={{ paper: classes.customPaper }} title={<Box className={classes.timelineTitle}><AccessTime color="primary" fontSize="large" /><Box mx={1}>Application Timeline</Box></Box>} content={getTimelineContent()} fullWidth maxWidth="" handleClose={() => { setShowTimeline(false) }} />}
      <Breadcrumb value={[{ 'Dashboard': '/' }, { [program && program[0] ? program[0].name : '']: `/applications`, search: urlProgram }, { 'View application': `/applications/${programId}/view-application` }]} />
      <Box className={classes.headerWrapper} display="flex" justifyContent="space-between" flexWrap="wrap">
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <Typography className={classes.title}>Application ID: {applicationId}</Typography>
          {_.get(application, 'application_status', '') &&
            <StatusButton
              color={tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''] && tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''][application.application_status][1]}
              text={tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''] && tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''][application.application_status][0]}
            />
          }
          {application && program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && <Box className={classes.timelineText} mx={1} onClick={() => setShowTimeline(true)}>{'View timeline'}<ChevronRight fontSize="small" /></Box>}
        </Box>
        {application && (application.application_status === APPLICATIONREJECTED || application.application_status === SITEREJECTED) && program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP &&
          <AppButton fill={false} text="Edit & Resubmit" style={{ margin: 10 }} onClick={() => history.push({ pathname: `/applications/application-form`, search: `?${urlProgram}`, state: { application: application } })} />}
      </Box>
      <Box className={classes.stepperContainer}>
        {program && program[0] && program[0].program_key && <CustomStepper steps={steps} currentStep={application && tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''] && tableApplicationStatus[program && program[0] ? program[0].family_key ? program[0].family_key : program[0].program_key : ''][application.application_status][2]} status={application && application.application_status} formData={formData} program={program && program[0]} />}
      </Box>
      <Box className={classes.formContainer}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box className={classes.formHeading} p={1}>Application details</Box>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                {program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP &&
                  <>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Customer First Name</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.first_name', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Customer Last Name</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.last_name', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Email Address</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.email_address', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Address Line 1</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.address1', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Address Line 2</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.address2', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>City</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.city', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>State</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.state', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Zip</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.zip', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Phone Number</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.phone', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Battery Details</Box>
                      <Box mb={0.2}>
                        <Box className={classes.listValue} component="span" mr={3}>Encharge 3</Box>
                        <Box className={classes.listSubValue} component="span">{_.get(application, 'homeowner_info.encharge3', '-')}</Box>
                      </Box>
                      <Box>
                        <Box className={classes.listValue} component="span" mr={2.1}>Encharge 10</Box>
                        <Box className={classes.listSubValue} component="span">{_.get(application, 'homeowner_info.encharge10', '-')}</Box>
                      </Box>
                    </Box>
                  </>
                }
                {program && program[0] && program[0].family_key && application &&
                  <Box mx={1} mt={2}>
                    <Box className={classes.listKey}>Utility</Box>
                    {program.map(programDetail => {
                      if (programDetail.id === application.program_id) {
                        return <Box className={classes.listValue}>{programDetail.utility_name?.toUpperCase()}</Box>
                      }
                    })}
                  </Box>
                }
                {program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && leftContent &&
                  leftContent.map((field) => (
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>{field.label}</Box>
                      <Box className={classes.listValue}>{_.get(field, 'value', '-')}</Box>
                    </Box>
                  ))
                }
              </Grid>
              <Grid item xs={12} sm={6}>
                {program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP &&
                  <>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>kW Capacity Committed for data sharing</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.kw_capacity_committed', '-')}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Program Option</Box>
                      <Box className={classes.listValue}>{application && application.homeowner_info ? programsTypes[application.homeowner_info.program_type] : '-'}</Box>
                    </Box>
                    <Box mx={1} my={2}>
                      <Box className={classes.listKey}>Electric Account Number</Box>
                      <Box className={classes.listValue}>{_.get(application, 'homeowner_info.electric_account_number', '-')}</Box>
                    </Box>
                  </>
                }
                {program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && rightContent &&
                  rightContent.map((field) => (
                    field.type && field.type === 'GROUPABLE_COUNTER' ?
                      <Box mx={1} my={2}>
                        <Box className={classes.listKey}>{field.label}</Box>
                        {field.value.map(value => (
                          Object.keys(value).map(val => (
                            <Box my={0.2} display="flex" justifyContent="space-between" maxWidth={150}>
                              <Box className={classes.listValue} component="span">{val ? enchargeText[val] : '-'}</Box>
                              <Box className={classes.listSubValue} component="span">{value[val] ? value[val] : '-'}</Box>
                            </Box>
                          ))
                        )
                        )}
                      </Box> :
                      <Box mx={1} my={2}>
                        <Box className={classes.listKey}>{field.label}</Box>
                        {field.label && field.label === 'Incentive Category' ?
                          <Box className={classes.listValue}>{field && field.value ? incentiveCategories[field.value] : ''}</Box> :
                          field.label && field.label === 'Program Payment Option Type' ?
                            <Box className={classes.listValue}>{field && field.value ? paymentTypes[field.value] : ''}</Box> :
                            <Box className={classes.listValue}>{_.get(field, 'value', '-')}</Box>}
                      </Box>
                  ))
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className={classes.formHeading} p={1}>Files Uploaded</Box>
            {program && program[0] && program[0].program_key === PROGRAM_KEY.APS_RBP &&
              <>
                <Box className={classes.applicationFile} mx={1} my={2}>
                  <img src={pdfIcon} alt="" />
                  <Box className={classes.fileHelperText} mt={2}>
                    Scanned Copy of Program T&C Document
                  </Box>
                  <Box className={classes.fileName} onClick={() => { application && application.signed_tandc_form_downloadable_url && downloadFile(application.signed_tandc_form_downloadable_url, 'blank') }}>
                    {application && application.signed_tandc_form_url ?
                      <Box>
                        <img src={download} className={classes.downloadIcon} alt="" />
                        {trimNameWithoutExtension(application.signed_tandc_form_url.split('/')[application.signed_tandc_form_url.split('/').length - 1])}
                      </Box>
                      : ''}
                  </Box>
                </Box>
                {application && (application.application_status === APPLICATIONAPPROVED || application.application_status === SITESUBMITTED || application.application_status === SITEAPPROVED || application.application_status === SITEREJECTED) &&
                  <>
                    <Box className={classes.formHeading} p={1} mt={3}>Enphase Site ID details</Box>
                    <Box mt={1}>
                      {application && application.site_id ?
                        <Box className={classes.siteDetail} display="flex" justifyContent="space-between" alignItems="center" px={1}>
                          <Box>{`Enphase Site ID : ${application.site_id}`}</Box>
                          {application && application.application_status === SITEREJECTED &&
                            <AppButton fill={false} text="Edit and Resubmit" style={{ margin: 0 }} onClick={() => setOpenSiteModal(true)} />
                          }
                        </Box>
                        : <AppButton fill={false} text="Submit Enphase Site Id" style={{ margin: 10 }} onClick={() => setOpenSiteModal(true)} />
                      }
                    </Box>
                  </>
                }
                {application && application.log_history && application.log_history.length > 0 && application.log_history[application.log_history.length - 1].application_status === SITEREJECTED && (
                  <>
                    <Box className={classes.formHeading} p={1} mt={3}>Reason for Rejection</Box>
                    <Box m={1} className={classes.siteDetail}>
                      {application.log_history[application.log_history.length - 1].message}
                    </Box>
                  </>
                )}
              </>
            }
            {program && program[0] && program[0].program_key !== PROGRAM_KEY.APS_RBP && fileContent &&
              <>
                <Box display="flex" flexWrap="wrap">
                  {fileContent.map(file => (
                    <Box className={classes.applicationFile} style={{ maxWidth: '200px' }}>
                      {file.type === 'text/csv' ? <Icon src="csvFile" width={55} height={65} /> : <img src={pdfIcon} alt="" />}
                      <Box className={classes.fileHelperText} mt={2} minHeight="30px">
                        {file.label}
                      </Box>
                      <Box className={classes.fileName} onClick={() => { file.downloadableUrl && downloadUploadedFile(file.downloadableUrl, file.value.split('/')[file.value.split('/').length - 1]) }}>
                        {file.value ?
                          <Box>
                            <img src={download} className={classes.downloadIcon} alt="" />
                            {trimName(file.value.split('/')[file.value.split('/').length - 1])}
                          </Box>
                          : ''}
                      </Box>
                    </Box>
                  ))}
                </Box>
                <Box>
                  {application && application.log_history && application.log_history.length > 0 && (application.log_history[application.log_history.length - 1].application_status === APPLICATIONREJECTED || application.log_history[application.log_history.length - 1].application_status === SITEREJECTED) && (
                    <>
                      <Box className={classes.formHeading} p={1} mt={3}>Reason for Rejection</Box>
                      <Box m={1} className={classes.siteDetail}>
                        {application.log_history[application.log_history.length - 1].message}
                      </Box>
                    </>
                  )}
                </Box>
              </>
            }
          </Grid>
        </Grid>
        <Divider />
        <Box display="flex" justifyContent="flex-end">
          <Box minWidth="200px">
            <AppButton fill={false} text="Back" onClick={() => history.push(`/applications?${urlProgram}`)} />
          </Box>
        </Box>
      </Box>
    </Box >
  )
}

export default ViewApplication